import { IoDiamondOutline, IoDocumentTextOutline } from "react-icons/io5";
import {
  LockIcon,
  LogoutIcon,
  NotificationIcon,
  ProfileIcon2,
  SpecialEventIcon,
} from "./assets/designedPickedIcons";
import dummyPlace1 from "./assets/place-dummy-1.png";
import { AiOutlineInfoCircle } from "react-icons/ai";
import dummyPlace2 from "./assets/fresh-fruits.png";
import { MdFeedback } from "react-icons/md";
import { MdOutlineFeedback } from "react-icons/md";
export const categories = [
  { key: "adventure", name: "Adventure", color: "rgba(13, 45, 125, 1)" },
  { key: "kids", name: "Kids", color: "rgba(251, 188, 4, 1)" },
  { key: "culture", name: "Culture", color: "rgba(165, 100, 25, 1)" },
  { key: "date", name: "Date", color: "rgba(204, 44, 218, 1)" },
  { key: "restaurant", name: "Restaurant", color: "rgba(255, 161, 74, 1)" },
  { key: "sports", name: "Sports", color: "rgba(33, 139, 37, 1)" },
  { key: "countryFairs", name: "Country fairs", color: "rgba(55, 75, 75, 1)" },
  { key: "music", name: "Music", color: "rgba(218, 117, 117, 1)" },
  { key: "learning", name: "Learning", color: "rgba(38, 181, 191, 1)" },
  { key: "gaming", name: "Gaming", color: "rgba(215, 80, 19, 1)" },
  { key: "animals", name: "Animals", color: "rgba(132, 127, 0, 1)" },
  { key: "events", name: "Events", color: "rgba(253, 77, 147, 1)" },
  { key: "specialEvents", name: "Special Events", icon: SpecialEventIcon },
];
export const discountFilters = [
  { title: "Groups", color: "rgba(18, 118, 239, 1)" },
  { title: "Day", color: "rgba(254, 48, 48, 1)" },
  { title: "Single use", color: "rgba(91, 198, 21, 1)" },
];
export const dummyPlaces = [
  {
    title: "Royale Cuisine",
    image: dummyPlace1,
    category: "Restaurants",
    location: "101 Depths Road, Hamletville, EU",
    status: "active",
    type: "resturant",
    genderType: "male",
  },
  {
    title: "Burger Kings",
    image: dummyPlace1,
    category: "Fast Food",
    location: "202 Main Street, Foodie Town, EU",
    status: "pending",
    type: "resturant",
    genderType: "female",
  },
  {
    title: "Pizza Corner",
    image: dummyPlace1,
    category: "Restaurants",
    location: "101 Depths Road, Hamletville, EU",
    status: "active",
    type: "special-event",
    genderType: "male",
  },
  {
    title: "Burger Shack",
    image: dummyPlace1,
    category: "Fast Food",
    location: "202 Main Street, Foodie Town, EU",
    status: "pending",
    type: "date",
    genderType: "female",
  },
  {
    title: "Sushi Paradise",
    image: dummyPlace1,
    category: "Japanese Cuisine",
    location: "303 Ocean Avenue, Sushi City, EU",
    status: "active",
    type: "event",
    genderType: "male",
  },
  {
    title: "Taco Haven",
    image: dummyPlace1,
    category: "Mexican Cuisine",
    location: "404 Fiesta Lane, Taco Town, EU",
    status: "rejected",
    type: "sports",
    genderType: "female",
  },
  {
    title: "Vegan Delights",
    image: dummyPlace1,
    category: "Vegan",
    location: "505 Greenway, Eco City, EU",
    status: "active",
    type: "kids",
    genderType: "male",
  },
  {
    title: "Sweet Tooth Bakery",
    image: dummyPlace1,
    category: "Bakery",
    location: "606 Sugar Road, Dessertville, EU",
    status: "pending",
    type: "culture",
    genderType: "female",
  },
  {
    title: "Coffee Corner",
    image: dummyPlace1,
    category: "Café",
    location: "707 Brew Street, Coffee Town, EU",
    status: "active",
    type: "culture",
    genderType: "male",
  },
  {
    title: "BBQ Grill House",
    image: dummyPlace1,
    category: "Barbecue",
    location: "808 Smoke Way, Grill City, EU",
    status: "rejected",
    type: "resturant",
    genderType: "female",
  },
  {
    title: "Pasta Palace",
    image: dummyPlace1,
    category: "Italian Cuisine",
    location: "909 Noodle Drive, Pasta Town, EU",
    status: "active",
    type: "special-event",
    genderType: "female",
  },
  {
    title: "Deli Delight",
    image: dummyPlace1,
    category: "Deli",
    location: "1001 Sandwich Blvd, Deli City, EU",
    status: "pending",
    type: "special-event",
    genderType: "male",
  },
  {
    title: "Seafood Shack",
    image: dummyPlace1,
    category: "Seafood",
    location: "1112 Fishy Lane, Seafood Town, EU",
    status: "active",
    type: "culture",
    genderType: "female",
  },
  {
    title: "Ice Cream Parlor",
    image: dummyPlace1,
    category: "Dessert",
    location: "1213 Chill Street, Ice Cream City, EU",
    status: "rejected",
    type: "special-event",
    genderType: "male",
  },
  {
    title: "Steakhouse Grill",
    image: dummyPlace1,
    category: "Steakhouse",
    location: "1314 Meat Avenue, Steak Town, EU",
    status: "active",
    type: "special-event",
    genderType: "female",
  },
  {
    title: "Dim Sum House",
    image: dummyPlace1,
    category: "Chinese Cuisine",
    location: "1415 Wok Way, Dim Sum City, EU",
    status: "pending",
    type: "special-event",
    genderType: "male",
  },
  {
    title: "Pancake Palace",
    image: dummyPlace1,
    category: "Breakfast",
    location: "1516 Flapjack Lane, Breakfast Town, EU",
    status: "active",
    type: "kids",
    genderType: "female",
  },
  {
    title: "Top Hills",
    image: dummyPlace1,
    category: "Adventure",
    location: "1617 Mountain Road, Top Hills, EU",
    status: "active",
    type: "adventure",
    genderType: "male",
  },
  {
    title: "Top Hills 2",
    image: dummyPlace1,
    category: "Adventure",
    location: "1617 Mountain Road, Top Hills, EU",
    status: "active",
    type: "adventure",
    genderType: "female",
  },
  {
    title: "Top Hills 3",
    image: dummyPlace1,
    category: "Adventure",
    location: "1617 Mountain Road, Top Hills, EU",
    status: "active",
    type: "adventure",
    genderType: "male",
  },
];
export const placesNavigatorOptions = [
  { title: "all", val: "", flowAt: 0, status: "all" },
  { title: "approved", val: "approved", flowAt: 1, status: "active" },
  { title: "pending", val: "pending", flowAt: 2, status: "pending" },
  { title: "rejected", val: "rejected", flowAt: 3, status: "rejected" },
];
export const resturantDiscountDetailsOptions = [
  { title: "All", color: "rgba(38, 40, 44, 1)" },
  { title: "Discount for groups", color: "rgba(42, 139, 242, 1)" },
  { title: "Specific Day", color: "rgba(42, 139, 242, 1)" },
  { title: "Single Use", color: "rgba(30, 181, 100, 1)" },
];
export const profileOptions = [
  { titleKey: "personalInformation", icon: <ProfileIcon2 size={30} /> },
  { titleKey: "changePassword", icon: <LockIcon size={30} /> },
  { titleKey: "premium", icon: <IoDiamondOutline size={30} /> },
  { titleKey: "termsAndConditions", icon: <IoDocumentTextOutline size={30} /> },
  { titleKey: "aboutUs", icon: <AiOutlineInfoCircle size={30} /> },
  { titleKey: "feedback", icon: <MdOutlineFeedback size={30} /> },
  { titleKey: "logOut", icon: <LogoutIcon size={30} /> },
];
export const userProfileOptions = [
  { titleKey: "personalInformation", icon: <ProfileIcon2 size={30} /> },
  { titleKey: "notification", icon: <NotificationIcon /> },
  { titleKey: "changePassword", icon: <LockIcon size={30} /> },
  { titleKey: "termsAndConditions", icon: <IoDocumentTextOutline size={30} /> },
  { titleKey: "aboutUs", icon: <AiOutlineInfoCircle size={30} /> },
  { titleKey: "feedback", icon: <MdOutlineFeedback size={30} /> },
  { titleKey: "logOut", icon: <LogoutIcon size={30} /> },
];
export const dummyShakes = [
  { title: "VIRGIN MOJITO", price: "₹395" },
  { title: "WATERMELON MOJITO", price: "₹395" },
  { title: "BLUE LAGOON", price: "₹395" },
  { title: "KITKAT SHAKE", price: "₹450" },
  { title: "OREO SHAKE", price: "₹450" },
  { title: "CHOCHLATE SHAKE", price: "₹450" },
];
export const dummyPlaters = [
  { title: "CHICKEN PLATTER", price: "₹395" },
  { title: "HEAVY PLATTER", price: "₹395" },
  { title: "FAMILY PLATTER", price: "₹395" },
  { title: "LARGE PLATTER", price: "₹395" },
];
export const dummyBreads = [
  { title: "CHEESE GARLIC B READ", nonVegPrice: "₹450", vegPrice: "₹550" },
  { title: "PENNE ALFREDO PASTA", nonVegPrice: "₹450", vegPrice: "₹550" },
  { title: "PENNE ALFREDO PASTA", nonVegPrice: "₹450", vegPrice: "₹550" },
];
export const dummyApetizers = [
  { title: "CHILLI POTATO", price: "₹450" },
  { title: "HONEY CHILLI POTATO", price: "₹450" },
  { title: "HARA BHARA KABAB", price: "₹495" },
  { title: "VEG MANCHURIAN", price: "₹450" },
  { title: "VEG SPRING ROLL", price: "₹495" },
  { title: "TANDOORI SOYA CHAAP", price: "₹450" },
];
export const discountCategories2 = [
  {
    title: "Discount for groups",
    value: "group",
    checked: false,
    color: "rgba(18, 118, 239, 1)",
  },
  {
    title: "Specific day",
    value: "specific_day",
    checked: false,
    color: "rgba(254, 48, 48, 1)",
  },
  {
    title: "Single use",
    value: "single_entry",
    checked: false,
    color: "rgba(91, 198, 21, 1)",
  },
];
export const dummyDays = [
  { day: "Monday", checked: false },
  { day: "Tuesday", checked: false },
  { day: "Wednesday", checked: false },
  { day: "Thursday", checked: false },
  { day: "Friday", checked: false },
  { day: "Saturday", checked: false },
  { day: "Sunday", checked: false },
];
export const dummyMyCommercials = [
  {
    title: "Boating Aly",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Molan Valley",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Bahria Heights",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Underwater City",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "City of dasana",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "TKR",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Ember s Land",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
];
export const dummyRecentCommercials = [
  {
    title: "Boating Aly",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Elva Restaurant",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Bahria Heights",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Underwater City",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "City of Almonds",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "TKR",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Wish Land",
    video: "/resturant-dummy-video.mp4",
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
];
export const dummyNearYouPlaces = [
  {
    title: "Emolga `s Land",
    photo: dummyPlace1,
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "WonderLand",
    photo: dummyPlace1,
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Season Delights",
    photo: dummyPlace1,
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "KFC Pizza",
    photo: dummyPlace1,
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
  {
    title: "Bahria `s Wonders",
    photo: dummyPlace1,
    description: "Lorem ipsum dolor sit ammet is just simplet asjsadks",
  },
];
export const dummyFaqs = [
  {
    question: "faqQuestion1",
    answer: "faqAnswer1",
  },
  {
    question: "faqQuestion2",
    answer: "faqAnswer2",
  },
  {
    question: "faqQuestion3",
    answer: "faqAnswer3",
  },
  {
    question: "faqQuestion4",
    answer: "faqAnswer4",
  },
];
export const dummyTermsAndConditions = [
  {
    title: "termsTitle1",
    paragraph: "termsParagraph1",
  },
  {
    title: "termsTitle2",
    paragraph: "termsParagraph2",
  },
  {
    title: "termsTitle3",
    paragraph: "termsParagraph3",
  },
  {
    title: "termsTitle4",
    paragraph: "termsParagraph4",
  },
  {
    title: "termsTitle5",
    paragraph: "termsParagraph5",
  },
];
export const dummyRecentSaved = [
  {
    title: "Royale Cuisine",
    image: dummyPlace1,
    type: "resturant",
    location: "101 Depths Road, Hamletville, EU",
    reviews: "(2,500+)",
    ratings: 4.2,
    isOpen: true,
  },
  {
    title: "Fresh Fruits",
    image: dummyPlace2,
    type: "resturant",
    location: "101 Depths Road, Hamletville, EU",
    reviews: "(2,500+)",
    ratings: 4.2,
    isOpen: true,
  },
  {
    title: "Tehzeeb",
    image: dummyPlace2,
    type: "resturant",
    location: "101 Depths Road, Hamletville, EU",
    reviews: "(2,500+)",
    ratings: 4.2,
    isOpen: true,
  },
];
export const types = ["market", "restaurant", "cafe", "hotel", "other"];
export const supportedLanguages = [
  { countryCode: "GB", name: "English" }, // GB for United Kingdom
  { countryCode: "IT", name: "Italian" }, // Italy
  { countryCode: "ES", name: "Spanish" }, // Spain
  { countryCode: "BR", name: "Brazilian" }, // Brazil
  { countryCode: "PT", name: "Portuguese" }, // Portugal
  { countryCode: "FR", name: "French" }, // France
  { countryCode: "RU", name: "Russian" }, // Russia
  { countryCode: "DE", name: "Deutsch" }, // Germany
];
